<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fm-no">Dedication</h2>
<p class="center">This book is dedicated to my mum, Hazel Gibson</p>
<p class="center">I love her heaps and am blessed to have had her love and support in all that I have done in life, wherever I am in the world. She has always been there for me and I am hugely grateful to this amazing, brave, clever woman.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm03.vue?22f79e1c